import { Component, Input } from '@angular/core';

@Component({
  selector: 'l-progress-ring',
  standalone: true,
  templateUrl: './progress-ring.component.html',
})
export class ProgressRingComponent {

  @Input()
  public progress: number = 0;

  @Input()
  public showLabel: boolean = true;

  @Input()
  public size: 'sm' | 'md' = 'md';

  public get containerClass(): string {
    return this.size === 'sm'
      ? 'relative grid h-7 w-7 place-items-center'
      : 'relative grid h-16 w-16 place-items-center';
  }

  public get labelClass(): string {
    return this.size === 'sm'
      ? 'relative z-10 grid h-full w-full place-items-center rounded-full bg-transparent text-[10px] font-semibold text-lWhite/90'
      : 'relative z-10 grid h-full w-full place-items-center rounded-full bg-transparent text-sm font-semibold text-lWhite/90';
  }

  public get normalizedProgress(): number {
    return Math.min(100, Math.max(0, Math.round(this.progress ?? 0)));
  }
}